module.exports = __webpack_public_path__ + "img/ur3_04.756a8b8c.jpg";